jQuery.extend(jQuery.expr[':'], {
    focusable: function(el, index, selector){
        return $(el).is('a, input, select, textarea, .select2-container,[tabindex][tabindex!=-1], [contenteditable="true"]');
    }
});
